import { sharedJa } from './pages/shared'
import { sendSmsJa } from './pages/sendSms'
import { dashboardJa } from './pages/dashboard'
import { smsSearchJa } from './pages/smsSearch'
import { realTimeProgressJa } from './pages/realTimeProgress'
import { exportRecordsJa } from './pages/exportRecords'
import { platformSettingsJa } from './pages/platformSettings'
import { apiKeysJa } from './pages/apiKeys'
import { apiDocsJa } from './pages/apiDocs'
import { accountJa } from './pages/account'

export default {
  lang: {
    zhCN: '简体中文',
    enUS: 'English',
    jaJP: '日本語',
    select: '言語',
  },
  menu: {
    dashboard: 'ダッシュボード',
    sendSms: 'SMS送信',
    realTimeProgress: 'リアルタイム進捗',
    pendingQueue: '処理待ち',
    smsSearch: 'SMS検索',
    exportRecords: 'エクスポート履歴',
    apiIntegration: 'API連携',
    apiDocs: 'APIドキュメント',
    apiKeys: 'キーとコールバック',
    platformSettings: '設定',
  },
  nav: {
    overview: '概要',
    smsService: 'SMSサービス',
    development: '開発者',
    developConfig: '開発と設定',
    collapseSidebar: 'サイドバーを閉じる',
    efficientReach: '高速配信',
    efficientReachDesc: '世界中へ秒速SMS',
  },
  layout: {
    balance: 'Balance',
    accountSettings: 'アカウント設定',
    accountSettingsDesc: 'パスワードとメール',
    logout: 'ログアウト',
    logoutConfirm: 'ログアウト確認',
    logoutConfirmText: 'ログアウトしますか？',
    cancel: 'キャンセル',
    confirm: 'ログアウト',
    online: 'オンライン',
  },
  login: {
    badge: 'Global SMS Network',
    heroTitle: '世界とつながる',
    heroAccent: '即時配信',
    heroDesc: '{site}は、OTP・マーケティング・通知向けの安定した低遅延メッセージング基盤を提供します。',
    statCountries: '対応国',
    statUptime: '可用性',
    statDelivery: '平均配信',
    username: 'ユーザー名',
    password: 'パスワード',
    captcha: '認証コード',
    usernamePlaceholder: 'ユーザー名を入力',
    passwordPlaceholder: 'パスワードを入力',
    captchaPlaceholder: '認証コードを入力',
    submit: 'コンソールへ',
    submitting: 'ログイン中…',
    portalFail: 'ポータルログインに失敗しました',
    required: 'ユーザー名とパスワードを入力してください',
    fail: 'ログインに失敗しました',
    footer: '© {year} {site}',
  },
  common: {
    loading: '読み込み中…',
    save: '保存',
    close: '閉じる',
    search: '検索',
    reset: 'リセット',
    export: 'エクスポート',
    refresh: '更新',
    total: '{n} 件',
    noData: 'データなし',
    success: '成功',
    failed: '失敗',
    networkError: 'ネットワークエラー',
    timeout: 'タイムアウト',
    sessionExpired: 'セッションが期限切れです',
    unknown: '不明',
  },
  badge: {
    marketing: 'マーケティング',
  },
  shared: sharedJa,
  sendSms: sendSmsJa,
  dashboard: dashboardJa,
  smsSearch: smsSearchJa,
  realTimeProgress: realTimeProgressJa,
  exportRecords: exportRecordsJa,
  platformSettings: platformSettingsJa,
  apiKeys: apiKeysJa,
  apiDocs: apiDocsJa,
  account: accountJa,
}
